import { AfterViewInit, Directive, ElementRef, EventEmitter, inject, Output } from '@angular/core';
import { Subject } from 'rxjs';
@Directive({ selector: '[sklLoader]' })
export class LoaderDirective implements AfterViewInit {

    @Output() public sklLoader: EventEmitter<IntersectionObserverEntry> = new EventEmitter();

    private readonly element = inject(ElementRef);
    private load$ = new Subject<IntersectionObserverEntry>();
    private intersectionObserver!: IntersectionObserver;

    public ngAfterViewInit(): void {
        this.load$.subscribe(event => {
            this.sklLoader.emit(event);
        })
        this.initIntersectionObserver();
    }

    public ngOnDestroy(): void {
        this.intersectionObserver.disconnect();
        this.load$.unsubscribe();
    }

    private initIntersectionObserver(): void {
        this.intersectionObserver = new IntersectionObserver(changes => {
            const firstChange = changes[0];
            if (firstChange.isIntersecting) {
                this.load$.next(firstChange);
            }
        }, {});
        this.intersectionObserver.observe(this.element.nativeElement);
    }
}
